export default __webpack_public_path__ + "static/media/logo-symbol.f59cbbd1.svg";